import { ApiError, ServerError } from "@/types/api";
import { reactive } from "vue";

const useErrors = reactive({
  url: "" as string,
  status: -1 as number,
  statusText: "" as string,
  messages: [] as ServerError[],
  visible: false,
});

const clearErrors = (): void => {
  useErrors.url = "";
  useErrors.status = -1;
  useErrors.statusText = "";
  useErrors.messages = [];
  useErrors.visible = false;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const errHandler = (err: any) => {
  if (err instanceof ApiError) {
    useErrors.url = err.response.url;
    useErrors.status = err.response.status;
    useErrors.statusText = err.response.statusText;
    err.json.then((json) => {
      useErrors.messages = json.messages;
    });
  } else {
    useErrors.messages = [{ type: 500, code: "I001", description: err }];
  }
  useErrors.visible = true;
};
const fetchErrHandler = errHandler;
const updateErrHandler = errHandler;
export {
  useErrors,
  clearErrors,
  errHandler,
  fetchErrHandler,
  updateErrHandler,
};
